import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community';
import { AgGridBaseComponent } from '../core/components/ag-grid-base.component';
import { DashboardReviewData } from '../core/models/dashboard-review-data.model';
import { Event } from '../core/models/event.model';
import { Placeholder } from '../core/models/placeholder.model';
import { PlaceholderPipe } from '../core/models/placeholder-pipe.model';
import { MomentPipe } from '../core/pipes/moment.pipe';
import { TranslatePipe } from '../core/pipes/translate.pipe';
import { DashboardService } from '../core/services/dashboard.service';
import { EventService } from '../core/services/event.service';
import { LocalizationService } from '../core/services/localization.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.css']
})
export class EventComponent extends AgGridBaseComponent implements OnInit {

  country: string;
  cpa: string;
  cpaName: string;
  generatedOn: number;
  events: Observable<Event[]> | undefined;

  private columnDefs: ColDef[] = [
    { field: 'code', filter: 'agTextColumnFilter', headerValueGetter: () => this.createHeader('T21') },
    { field: 'discountProductGroup', filter: 'agTextColumnFilter', headerValueGetter: () => this.createHeader('T22') },
    { field: 'thresholdType', filter: 'agTextColumnFilter', headerValueGetter: () => this.createHeader('T23') },
    { field: 'rampUpStartDate', filter: 'agDateColumnFilter', headerValueGetter: () => this.createHeader('T24'), valueFormatter: this.formatDate.bind(this) },
    { field: 'rampUpEndDate', filter: 'agDateColumnFilter', headerValueGetter: () => this.createHeader('T25'), valueFormatter: this.formatDate.bind(this) },
    { field: 'initialDiscountPercent', filter: 'agNumberColumnFilter', headerValueGetter: () => this.createHeader('T26'), type: 'rightAligned', valueFormatter: this.formatPercentage },
    { field: 'currentDiscountPercent', filter: 'agNumberColumnFilter', headerValueGetter: () => this.createHeader('T27'), type: 'rightAligned', valueFormatter: this.formatPercentage },
    { field: 'nextDiscountStartDate', filter: 'agDateColumnFilter', headerValueGetter: () => this.createHeader('T28'), valueFormatter: this.formatDate.bind(this) },
    { field: 'nextDiscountPercent', filter: 'agNumberColumnFilter', headerValueGetter: () => this.createHeader('T29'), type: 'rightAligned', valueFormatter: this.formatPercentage },
  ];

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected dashboardService: DashboardService,
    protected eventService: EventService,
    protected localizationService: LocalizationService,
    protected momentPipe: MomentPipe,
    protected translatePipe: TranslatePipe
  ) {
    super(localizationService, momentPipe, translatePipe);

    this.country = this.activatedRoute.snapshot.queryParams.country;
    this.cpa = this.activatedRoute.snapshot.queryParams.cpa;
  }

  get placeholders(): Placeholder[] {
    return [
      Placeholder.create('allRowCount', this.allRowCount, true),
      Placeholder.create('displayedRowCount', this.allRowCount, true),
      Placeholder.create('generatedOn', this.generatedOn, false, PlaceholderPipe.create('local-date', 'D MMM YYYY H:mm'))
    ];
  }

  ngOnInit(): void {
    this.dashboardService.getDashboardReviewData(this.cpa).subscribe((dashboardReviewData: DashboardReviewData) => {
      const dashboards = dashboardReviewData.getDashboards();
      this.cpaName = dashboards[0]?.getCpaName() || '';
      this.gridOptions?.api?.refreshHeader();
    });

    this.events = this.eventService.getEvents(this.cpa);
    this.generatedOn = Date.now();
    this.initializeGridOptions(this.columnDefs);
  }

}
